// extracted by mini-css-extract-plugin
export var container = "_du-1";
export var cornerButtonContainer = "_du-6";
export var disabled = "_du-2";
export var dragActive = "_du-3";
export var fileContainer = "_du-5";
export var hiddenInput = "_du-4";
export var widthContainer = "_du-0";